import { Component, Input, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { SearchableListService } from './services/searchable-list.service';

@Component({
  selector: 'app-searchable-list',
  templateUrl: './searchable-list.component.html',
  styleUrls: ['./searchable-list.component.scss'],
})
export class SearchableListComponent implements OnInit {
  @Input() inputList: Array<any> = [];
  @Input() currentItems: Array<any> = null;
  @Input() displayProperties: Array<string> = ['name'];
  @Input() searchProperties: Array<string> = ['name'];
  @Input() multiSelect: boolean = false;
  @Input() valueProperty: string = null;
  @Input() comparisonProperties: {
    currentItemProperty: string;
    listItemProperty: string;
  } = null;
  @Input() displayNameSeparator = '';

  public displayList: Array<any> = [];

  public searchString = '';
  public filteredList: Array<any> = null;

  private selectedList: Array<any> = [];

  constructor(
    private componentService: SearchableListService,
    private popoverController: PopoverController
  ) {}

  ngOnInit() {
    this.mapListToDisplayList(this.inputList);
  }

  private mapListToDisplayList(list: Array<any>): void {
    let newCurrentItems = [];

    this.displayList = list
      .map((item) => {
        /* Deep copy the item */
        let newItem = JSON.parse(JSON.stringify(item));

        /* Build displayName from displayProperties, only adding displayNameSeparator if there is something to separate */
        newItem.DisplayName = '';
        let usedDisplayProperties: Array<string> = [];

        for (const displayProperty of this.displayProperties) {
          if (newItem[displayProperty]) {
            usedDisplayProperties.push(newItem[displayProperty]);
          }
        }

        if (usedDisplayProperties.length) {
          newItem.DisplayName = usedDisplayProperties.join(
            this.displayNameSeparator
          );
        }

        if (this.currentItems) {
          /* Check if any item in the currentItems list is the same as this item */
          newItem.Selected = this.currentItems.some((aItem) =>
            this.compareObjects(aItem, item)
          );

          if (newItem.Selected) {
            newCurrentItems.push(newItem);
          }
        }

        return newItem;
      })
      .sort((item) => (item.Selected ? -1 : 1));

    this.currentItems = JSON.parse(JSON.stringify(newCurrentItems));
    this.componentService.setSelectedItems(this.currentItems);
  }

  public filterList(): void {
    // get the value of the key pressed and make it lowercase
    let filter = this.searchString.toLowerCase();
    this.filteredList = null;

    if (filter == '') {
      this.filteredList = null;
      return;
    }

    this.filteredList = this.displayList.filter((item) => {
      for (const field of this.searchProperties) {
        if (item[field].toLowerCase().includes(filter)) {
          return true;
        }
      }
      return false;
    });
  }

  public itemClick(item: any): void {
    if (this.multiSelect) {
      item.Selected = !item.Selected;

      this.selectedList = this.displayList.filter((fItem) => {
        return fItem.Selected;
      });

      this.setSelectedList();

      return;
    }

    if (!this.multiSelect) {
      this.selectedList = [item];

      this.setSelectedList();

      this.dismissComponent();

      return;
    }
  }

  /* Dismiss modal */
  private dismissComponent(): void {
    this.popoverController.dismiss();
  }

  private setSelectedList(): void {
    this.componentService.setSelectedItems(
      JSON.parse(JSON.stringify(this.selectedList))
    );
  }

  private compareObjects(a: any, b: any): boolean {
    if (this.comparisonProperties && a && b) {
      return (
        a[
        this.valueProperty || this.comparisonProperties.currentItemProperty
        ] === b[this.comparisonProperties.listItemProperty]
      );
    }

    if (this.valueProperty) {
      return a === b[this.valueProperty];
    }

    return JSON.stringify(a) == JSON.stringify(b);
  }
}
